<div class="bg-white rounded-3 border border-secondary-subtle p-4">
  <h1 class="fs-4 fw-bold text-primary mb-1">1. Datos iniciales</h1>
  <p class="text-secondary mb-4">Completa los campos requeridos</p>

  <form>
    <div class="row g-4">
      <!-- RUT -->
      <div class="col-md-6">
        <label for="rut" class="form-label">RUT<span class="text-danger">*</span></label>
        <input id="rut" class="form-control" placeholder="12.345.678-9" />
      </div>
      <!-- Número de documento -->
      <div class="col-md-6">
        <div class="d-flex align-items-center mb-1">
          <label for="documento" class="form-label mb-0">Número de documento<span class="text-danger">*</span></label>
          <span class="ms-1 text-secondary" title="¿Dónde encontrarlo?">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-info"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
          </span>
        </div>
        <input id="documento" class="form-control" placeholder="123456789" />
      </div>
      <!-- Correo electrónico -->
      <div class="col-md-6">
        <label for="email" class="form-label">Correo electrónico<span class="text-danger">*</span></label>
        <input id="email" type="email" class="form-control" placeholder="micorreo@mail.cl" />
      </div>
      <!-- Confirma tu correo electrónico -->
      <div class="col-md-6">
        <label for="confirmEmail" class="form-label">Confirma tu correo electrónico<span class="text-danger">*</span></label>
        <input id="confirmEmail" type="email" class="form-control" placeholder="micorreo@mail.cl" />
      </div>
      <!-- Teléfono de contacto -->
      <div class="col-md-6">
        <label for="telefono" class="form-label">Teléfono de contacto<span class="text-danger">*</span></label>
        <div class="d-flex">
          <input id="codigoPais" class="form-control w-auto me-2" placeholder="+569" />
          <input id="telefono" class="form-control flex-grow-1" placeholder="12345678" (input)="onPhoneInput($event)" />
        </div>
      </div>
      <!-- Código de referencia -->
      <div class="col-md-6">
        <div class="d-flex align-items-center mb-1">
          <label for="codigoReferencia" class="form-label mb-0">Código de referencia <span class="text-secondary">(opcional)</span></label>
          <span class="ms-1 text-secondary" title="¿Qué es esto?">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-info"><circle cx="12" cy="12" r="10"/><path d="M12 16v-4"/><path d="M12 8h.01"/></svg>
          </span>
        </div>
        <input id="codigoReferencia" class="form-control" placeholder="123456789" />
      </div>
    </div>

    <!-- Terms and Conditions -->
    <div class="form-check mt-4">
      <input class="form-check-input" type="checkbox" id="terms" />
      <label class="form-check-label" for="terms">
        He leído y acepto los <a href="#" class="text-primary text-decoration-underline">términos y condiciones</a> de Unipay
      </label>
    </div>

    <!-- reCAPTCHA simulado -->
    <div class="mx-auto my-4" style="max-width: 302px;">
      <div class="border rounded shadow-sm">
        <div class="d-flex align-items-center p-3 border-bottom">
          <input class="form-check-input me-2" type="checkbox" id="captcha-checkbox" style="width: 1.25rem; height: 1.25rem;" />
          <label for="captcha-checkbox" class="form-check-label flex-grow-1">No soy un robot</label>
          <div class="ms-auto">
            <img src="" alt="reCAPTCHA" style="height: 2rem; width: auto;" />
          </div>
        </div>
        <div class="bg-light p-2 text-center">
          <p class="text-secondary small mb-0">Privacidad - Términos</p>
        </div>
      </div>
    </div>
  </form>
</div>
